import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { StarRating } from "./StarRating";

export const ReviewForm = ({ formData, onFormChange, isEditing, submitting, onSubmit, onCancel }) => {
  const { t } = useTranslation();

  return (
    <Card className="bg-card border-border">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">
          {isEditing ? t('reviews.editReview') : t('reviews.writeReview')}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-3 gap-4">
          {[
            { field: "food_rating", label: t('reviews.food') },
            { field: "service_rating", label: t('reviews.service') },
            { field: "ambiance_rating", label: t('reviews.ambiance') },
          ].map(({ field, label }) => (
            <div key={field}>
              <Label className="text-sm text-muted-foreground mb-2 block">{label}</Label>
              <StarRating
                value={formData[field]}
                onChange={(v) => onFormChange({ ...formData, [field]: v })}
              />
            </div>
          ))}
        </div>

        <div>
          <Label className="text-sm text-muted-foreground mb-2 block">{t('reviews.comment')}</Label>
          <Textarea
            value={formData.comment}
            onChange={(e) => onFormChange({ ...formData, comment: e.target.value })}
            placeholder={t('reviews.commentPlaceholder')}
            className="bg-transparent border-border focus:border-primary min-h-[100px]"
            data-testid="review-comment-input"
          />
        </div>

        <div className="flex gap-2">
          <Button
            onClick={onSubmit}
            disabled={submitting}
            className="bg-primary text-primary-foreground hover:bg-primary/90"
            data-testid="submit-review-button"
          >
            {submitting ? "..." : (isEditing ? t('reviews.updateReview') : t('reviews.submitReview'))}
          </Button>
          <Button variant="outline" onClick={onCancel} className="border-border">
            {t('common.cancel')}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
